import React from 'react';
import { PlubosHomePage } from './pages/PlubosHomePage';
export function App() {
  return <PlubosHomePage data-id="element-0" />;
}